import React from "react";
import css from "../styles";


class ProjectConfigTable extends React.Component {
    
    render(){
        return (
          <div className="box-body table-responsive no-padding">
            <table className="table table-hover" style={css.table}>
              <thead>
                <tr>
                  <th>Title</th>
                  <th>Type</th>
                  <th>Choices</th>
                  <th>Mirror</th>
                  <th>Min</th>
                  <th>Max</th>
                </tr>
              </thead>
              
              <tbody>
                {this.props.bodyRows}
              </tbody>
            </table>
          </div>
        );
    }
}

export default ProjectConfigTable;


// WEBPACK FOOTER //
// ./src/views/projectconfig/components/ProjectConfigTable.js